(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const R = window.Rayor || {};

  const money = (cents) => {
    const fmt = R.money || '{{amount}}';
    const v = (cents / 100);
    const two = v.toFixed(2), noDec = Math.round(v).toString();
    const withSep = (n, sep, dec) => { const [a, b] = n.split('.'); return a.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (b ? dec + b : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
      amount: withSep(two, ',', '.'), amount_no_decimals: withSep(noDec, ',', '.'),
      amount_with_comma_separator: withSep(two, '.', ','), amount_no_decimals_with_comma_separator: withSep(noDec, '.', ','),
      amount_with_space_separator: withSep(two, ' ', ','), amount_with_apostrophe_separator: withSep(two, "'", '.')
    }[k] || two));
  };

  // drawers
  const openDrawer = (id) => { const d = document.getElementById(id); if (!d) return; d.classList.add('open'); document.documentElement.style.overflow = 'hidden'; d.querySelector('.panel')?.focus(); };
  const closeDrawer = (d) => { d.classList.remove('open'); document.documentElement.style.overflow = ''; };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); if (o.dataset.open === 'cart-drawer') refreshCart().then(() => openDrawer('cart-drawer')); else openDrawer(o.dataset.open); return; }
    const c = e.target.closest('[data-close]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.drawer.open').forEach(closeDrawer); });

  const toast = (msg) => { let t = $('.toast'); if (!t) { t = document.createElement('div'); t.className = 'toast'; document.body.appendChild(t); } t.textContent = msg; t.classList.add('show'); clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('show'), 2200); };

  // cart
  const renderCart = (cart) => {
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count || ''; el.dataset.n = cart.item_count; });
    const body = $('#cart-lines'); if (!body) return;
    if (!cart.item_count) { body.innerHTML = '<div class="empty"><p style="font-size:40px;margin:0">✦</p><p>Your cart is empty.</p><a class="btn btn-ghost" href="/collections/all" data-close>Explore products</a></div>'; $('#cart-foot').hidden = true; return; }
    $('#cart-foot').hidden = false;
    body.innerHTML = cart.items.map((it, i) => `
      <div class="line">
        <a href="${it.url}"><img src="${it.image ? it.image + (it.image.includes('?') ? '&' : '?') + 'width=160' : ''}" alt="" loading="lazy"></a>
        <div><a class="n" href="${it.url}">${it.product_title}</a>
          ${it.variant_title ? `<div class="v">${it.variant_title}</div>` : ''}
          <div class="qty"><button type="button" data-line="${i + 1}" data-q="${it.quantity - 1}" aria-label="Decrease">−</button><input value="${it.quantity}" readonly aria-label="Quantity"><button type="button" data-line="${i + 1}" data-q="${it.quantity + 1}" aria-label="Increase">+</button></div>
          <button class="rm" type="button" data-line="${i + 1}" data-q="0">Remove</button></div>
        <div class="p">${money(it.final_line_price)}</div>
      </div>`).join('');
    $('#cart-total').textContent = money(cart.total_price);
  };
  const refreshCart = () => fetch('/cart.js').then(r => r.json()).then(c => { renderCart(c); return c; });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('#cart-lines [data-line]'); if (!b) return;
    fetch((R.routes?.cart_change || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +b.dataset.line, quantity: +b.dataset.q }) }).then(r => r.json()).then(renderCart);
  });

  const addToCart = (id, qty, btn) => {
    if (btn) { btn.disabled = true; btn.dataset.label = btn.dataset.label || btn.innerHTML; btn.innerHTML = 'Adding…'; }
    return fetch((R.routes?.cart_add || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: +qty || 1 }] }) })
      .then(r => r.json().then(j => { if (!r.ok) throw new Error(j.description || 'Could not add'); return j; }))
      .then(() => refreshCart()).then(() => openDrawer('cart-drawer'))
      .catch(err => toast(err.message))
      .finally(() => { if (btn) { btn.disabled = false; btn.innerHTML = btn.dataset.label; } });
  };
  document.addEventListener('click', (e) => { const q = e.target.closest('[data-quick-add]'); if (!q) return; e.preventDefault(); addToCart(q.dataset.quickAdd, 1, null); });

  // product form
  const pf = document.getElementById('pf');
  if (pf) {
    const data = JSON.parse($('#product-json').textContent);
    const idInput = $('input[name="id"]', pf);
    const btns = $$('[data-atc]');
    const priceEl = $('[data-price]'), cmpEl = $('[data-compare]');
    const current = () => { const opts = $$('fieldset.opt', pf).map(fs => ($('input:checked', fs) || {}).value); return data.variants.find(v => v.options.every((o, i) => o === opts[i])); };
    const update = () => {
      const v = current();
      $$('fieldset.opt', pf).forEach((fs, i) => { const s = fs.querySelector('legend span'); const c = $('input:checked', fs); if (s && c) s.textContent = c.value; });
      if (!v) { btns.forEach(b => { b.disabled = true; b.textContent = 'Unavailable'; }); return; }
      idInput.value = v.id;
      priceEl && (priceEl.textContent = money(v.price));
      $$('[data-sticky-price]').forEach(e => e.textContent = money(v.price));
      if (cmpEl) { cmpEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      btns.forEach(b => { b.disabled = !v.available; b.textContent = v.available ? 'Add to cart' : 'Sold out'; });
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    pf.addEventListener('change', update);
    $$('[data-qty]').forEach(w => w.addEventListener('click', (e) => { const b = e.target.closest('button'); if (!b) return; const i = $('input', w); i.value = Math.max(1, (+i.value || 1) + (+b.dataset.step)); }));
    btns.forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); const q = $('input[name="quantity"]', pf); addToCart(idInput.value, q ? q.value : 1, b); }));
    update();
    // sticky
    const main = $('[data-main-atc]'), sticky = $('.sticky-atc');
    if (main && sticky && 'IntersectionObserver' in window) new IntersectionObserver(([en]) => sticky.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(main);
  }

  // gallery
  $$('[data-gallery]').forEach(g => {
    const sl = $('.slides', g), th = $$('.thumbs button', g), dots = $$('.dots i', g);
    const set = (i) => { th.forEach((b, j) => b.toggleAttribute('aria-current', i === j)); dots.forEach((d, j) => d.classList.toggle('on', i === j)); };
    sl.addEventListener('scroll', () => { const i = Math.round(sl.scrollLeft / sl.clientWidth); set(i); }, { passive: true });
    th.forEach((b, i) => b.addEventListener('click', () => sl.scrollTo({ left: i * sl.clientWidth, behavior: 'smooth' })));
    set(0);
  });

  // reveal
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(el => io.observe(el));
  } else $$('.reveal').forEach(el => el.classList.add('in'));

  // sort
  $$('[data-sort]').forEach(s => s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u; }));

  refreshCart().catch(() => {});
})();
